import React, { useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'How do I join a board game club?',
      answer: 'Create an account, search for clubs in your area, and click on a club to view details and join.'
    },
    {
      question: 'Is BoardVoyage free to use?',
      answer: 'Yes! BoardVoyage is completely free for players looking to find and join clubs.'
    },
    {
      question: 'Can I create my own club?',
      answer: 'Club creation is managed by our admin team. Contact us if you\'d like to register a new club.'
    },
    {
      question: 'How do I find clubs near me?',
      answer: 'Use the search bar on the homepage to enter your location and discover nearby board game clubs.'
    },
    {
      question: 'What types of board games are featured?',
      answer: 'We feature clubs for all types of board games, from classic games to modern strategy games and everything in between.'
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow bg-gray-50 py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Frequently Asked Questions</h1>
          <div className="bg-white rounded-lg shadow-md p-8">
            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div key={index} className="border-b border-gray-200 pb-4">
                  <button
                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                    className="w-full text-left flex justify-between items-center py-2"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                    <span className="text-2xl text-gray-500">
                      {openIndex === index ? '−' : '+'}
                    </span>
                  </button>
                  {openIndex === index && (
                    <p className="text-gray-600 mt-2">{faq.answer}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default FAQ;
